var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.26109 13.4663L6.71859 7.9987L1.26109 2.5412C0.918034 2.19814 0.918034 1.62302 1.26109 1.26988C1.60414 0.906642 2.18935 0.916732 2.5425 1.26988L8 6.72738L13.4575 1.26988C13.8006 0.916732 14.3757 0.916732 14.7389 1.26988C15.0921 1.61293 15.082 2.19814 14.7389 2.5412L9.27132 7.9987L14.7389 13.4663C15.082 13.8093 15.082 14.3845 14.7389 14.7376C14.3858 15.0908 13.8006 15.0807 13.4575 14.7376L8 9.28011L2.5425 14.7376C2.18935 15.0807 1.61423 15.0807 1.26109 14.7376C0.907944 14.3946 0.918034 13.8093 1.26109 13.4663Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.6ae72b1b8c516166b792f002e845ac0d.svg";
export { ForwardRef as ReactComponent };